// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3p4R0","head":"ProcedureTableInfo_head__2LCIr"};